import FormView from './FormView';
import * as styles from './styles.scss';

export interface FormViewProps {
  readonly onSubmit: () => void;
}

const RequestQuoteForm = ({ onSubmit }: FormViewProps) => (
  <div className={styles.requestQuoteForm}>
    <FormView onSubmit={onSubmit} />
  </div>
);

export default RequestQuoteForm;
